import { render, staticRenderFns } from "./NoticeEditor.vue?vue&type=template&id=1908ecb4&scoped=true"
import script from "./NoticeEditor.vue?vue&type=script&lang=ts"
export * from "./NoticeEditor.vue?vue&type=script&lang=ts"
import style0 from "./NoticeEditor.vue?vue&type=style&index=0&id=1908ecb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908ecb4",
  null
  
)

export default component.exports